import React from 'react';
import { Link } from 'react-router-dom';

const RESOURCES = [
  { label: 'Resume Templates', href: '#' },
  { label: 'Blog', href: '#' },
  { label: 'Job Search Tips', href: '#' },
  { label: 'Industry Guides', href: '#' },
];

const COMPANY = [
  { label: 'About Us', href: '#' },
  { label: 'Contact', href: '#' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms of Service', href: '#' },
];

function SocialIcon({ href, label, children }) {
  return (
    <a
      href={href}
      className="site-footer__social"
      aria-label={label}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner container">
        <div className="site-footer__grid">
          {/* Brand */}
          <div className="site-footer__col site-footer__brand">
            <Link to="/" className="site-footer__logo">
              <span className="site-footer__logo-icon" aria-hidden="true">🔥</span>
              <span className="site-footer__logo-text">RoastMyResume</span>
            </Link>
            <p className="site-footer__desc">
              Expert resume feedback to help you land more interviews and advance your career.
            </p>
            <div className="site-footer__socials">
              <SocialIcon href="https://x.com/lvarshitha7" label="Twitter">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </SocialIcon>
              <SocialIcon href="https://www.linkedin.com/in/lvarshitha7/" label="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </SocialIcon>
              
            </div>
          </div>

          {/* Services */}
          <div className="site-footer__col">
            <h3 className="site-footer__heading">Services</h3>
            <ul className="site-footer__links">
              <li>
                <Link to="/" className="site-footer__link">ATS Analyzer</Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="site-footer__col">
            <h3 className="site-footer__heading">Resources</h3>
            <ul className="site-footer__links">
              {RESOURCES.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="site-footer__link">{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="site-footer__col">
            <h3 className="site-footer__heading">Company</h3>
            <ul className="site-footer__links">
              {COMPANY.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="site-footer__link">{item.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="site-footer__divider" />

        <p className="site-footer__copy">
          © {year} RoastMyResume. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
